function DroppableDirective() {
  return {
    restrict: 'A',
    scope: {
      droppable: '='
    },
    link: function (scope, element) {
      element.droppable(scope.droppable || {});
    }
  };
}

DroppableDirective.$inject = [];

export default DroppableDirective;



// WEBPACK FOOTER //
// ./src/directives/droppable.js